import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-area" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "p1" }
const _hoisted_5 = { class: "p1" }

import { computed, reactive } from 'vue';
import type { AdminListTableField } from 'src/models/adminListTable';
import type { AdminGroup2 } from 'src/models/group2';
import type { AdminGroup3 } from 'src/models/group3';

type Group3Disp = AdminGroup3 & {
  g2Name: string;
};

interface SearchParam {
  parentId: number | null;
}

interface Group3TableState {
  search: SearchParam;
  // 検索ボタン押下時に確定する検索条件。フィルタはこちらのみを参照する（入力中は自動検索しない）
  applied: SearchParam;
  showDestroyModal: boolean;
  destroyingGroup3: AdminGroup3 | null;
}

const destroyModalTitle = '削除';
const destroyModalMsg = 'を削除してもよろしいですか？';

export default /*@__PURE__*/_defineComponent({
  __name: 'Group3Table',
  props: {
    groups3: {},
    groups2: {}
  },
  emits: ["edit", "destroy", "search"],
  setup(__props: any, { emit: __emit }) {

const initSearchParam = (): SearchParam => ({
  parentId: null,
});

const props = __props;

const emit = __emit;

const state = reactive<Group3TableState>({
  search: initSearchParam(),
  applied: initSearchParam(),
  showDestroyModal: false,
  destroyingGroup3: null,
});

const doSearch = (): void => {
  emit('search');
  state.applied = { ...state.search };
};

const group2Map = computed<Map<number, AdminGroup2>>(() => {
  return new Map(props.groups2.map(e => [e.id, e]));
});

const getGroup2Name = (group2Id: number | null): string => {
  if (group2Id == null) return '-';

  return group2Map.value.get(group2Id)?.name ?? '-';
};

const filteredGroups3 = computed<AdminGroup3[]>(() => {
  return props.groups3.filter(group3 => {
    if (state.applied.parentId == null || state.applied.parentId.toString() === '') return true;

    return group3.parentId === state.applied.parentId;
  });
});

const displayData = computed<Group3Disp[]>(() => {
  return filteredGroups3.value.map(g3 => {
    return {
      ...g3,
      g2Name: getGroup2Name(g3.parentId),
    };
  });
});

const edit = (obj: AdminGroup3) => {
  emit('edit', obj);
};

const tryDestroy = (obj: AdminGroup3) => {
  state.destroyingGroup3 = obj;
  state.showDestroyModal = true;
};

const doDestroy = () => {
  if (!state.destroyingGroup3) return;

  emit('destroy', state.destroyingGroup3);
  state.showDestroyModal = false;
};

const fields: AdminListTableField<Group3Disp>[] = [
  { name: 'g2Name', label: '事業所名' },
  { name: 'name', label: '部署名' },
  { name: 'dispOrder', label: '表示順' },
];

return (_ctx: any,_cache: any) => {
  const _component_AdminListTable = _resolveComponent("AdminListTable")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        class: "search-form",
        onSubmit: _withModifiers(doSearch, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { class: "form-control-label group2" }, "事業所", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.search.parentId) = $event))
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("option", { value: null }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groups2, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.id,
                value: e.id
              }, _toDisplayString(e.name), 9, _hoisted_3))
            }), 128))
          ], 512), [
            [_vModelSelect, state.search.parentId]
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-group search-btn ta-center" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary"
          }, "検索")
        ], -1))
      ], 32)
    ]),
    _createVNode(_component_AdminListTable, {
      "display-data": displayData.value,
      fields: fields,
      onStartEdit: edit,
      onStartDestroy: tryDestroy
    }, null, 8, ["display-data"]),
    (state.showDestroyModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: destroyModalTitle,
          "show-bottom-dismiss-button": true,
          onClose: doDestroy,
          onDismiss: _cache[1] || (_cache[1] = ($event: any) => (state.showDestroyModal = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_4, [
                _cache[5] || (_cache[5] = _createTextVNode("事業所名", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(getGroup2Name(state.destroyingGroup3?.parentId ?? null)), 1)
              ]),
              _createElementVNode("p", _hoisted_5, [
                _cache[7] || (_cache[7] = _createTextVNode("部署名", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(state.destroyingGroup3?.name), 1)
              ]),
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: destroyModalMsg
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})